import {DateRange} from '../../../stores/TimeIntervalStore';

export interface FilterTableDataRequest {
    channel: string;
    limit: number;
    interval: DateRange;
}

export interface FilterName {
    filter: string;
    count: number;
    ratio: number;
}

export const isFilterName = (value: any): value is FilterValue => {
    return value && typeof value.filter === 'string' && typeof value.count === 'number' && typeof value.ratio === 'number';
};

export const isFilterValue = (value: any): value is FilterValue => {
    return value && typeof value.value === 'string' && isFilterName(value);
};

export interface FilterValue extends FilterName {
    value: string;
}

export interface FilterNamesAndValues {
    filterNames: FilterName[];
    filterValues: FilterValue[];
}

export interface TopFilterData {
    searchFilterDepth: number;
    searchFilterUsageRatio: number;
    asn: FilterNamesAndValues;
    navigation: FilterNamesAndValues;
}



// WEBPACK FOOTER //
// ./src/types/api/dashboard/DashboardFilters.ts